import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_q8txr236ny: FaireBrandEntity = {
  token: "b_q8txr236ny",
  type: "brand",
  name: "Not Picasso",
  avatarUrl:
    "https://cdn.faire.com/fastly/fcda150295bfc537706f39b8ee2cda94fa29e101614396b88b5b7b3cc07f34c5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8cacaaf3190945f442ac2d2d26cff5da312c236a42deba028e8861039273a37a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fcda150295bfc537706f39b8ee2cda94fa29e101614396b88b5b7b3cc07f34c5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8cacaaf3190945f442ac2d2d26cff5da312c236a42deba028e8861039273a37a.jpeg",
  location: "Louisville, KY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 44,
  isTopShop: true,
  isInsider: true,
  description:
    "Partners in business and life, Cheyenne and Nathan are committed to bringing fun, colorful, and outrageously cute designs to life for everyday wear. Each laser-cut acrylic piece is lovingly hand-crafted from design to assembly in our home studio (also hand-made by us!) Now with a growing team, and an expanding collection of hair claws, stickers, pins, and more, Not Picasso is taking our joyful aesthetic world-wide.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:17.531Z",
    importedBy: "entity-db-cli",
  },
};
